import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { MemberResponseDto } from '../dtos/member.dto';

@Injectable({
    providedIn: 'root'
})
export class AccessRolesService {
    private readonly MEMBER_INFO = environment.outgoingRequestAPI + 'User';
    public constructor(private http: HttpClient) { }

    public getRole(): Observable<MemberResponseDto> {
        return this.http.get<MemberResponseDto>(this.MEMBER_INFO + '/memberinfo');
    }
}
